import { theme } from '@met/react-components';
import { darken } from 'polished';
import styled from 'styled-components';

const LinkButton = styled.span`
  color: ${theme.colors.red};
  cursor: pointer;

  &:hover {
    color: ${darken(0.1, theme.colors.red)};
  }
`;

export default LinkButton;
